import { authorizeGetRequest } from "api";
import { IPaginatedResponse } from "models";
import { IAppVersion } from "models/appVersion";

export const OtpApi = ({
  page,
  per_page,
  search,
}: {
  page: number;
  per_page: number;
  search: string;
}) => {
  if (search) search = search.replace("+", "%2B");
  return authorizeGetRequest<IPaginatedResponse<IAppVersion>>(
    `otp?page=${page}&per_page=${per_page}&search=${search}`
  );
};
